// Copyright (C) 2019 TANNER AG

import {
	SET_PURCHASE_PRICE,
	SET_RESIDUAL_VALUE,
	SET_ANNUAL_MILEAGE,
	SET_DRIVING_PROFILE,
	SET_EFFICIENT_HYBRID,
	SET_FUEL_PRICE,
	SET_HOLDING_PERIOD,
	ADD_BUS,
	SET_CONFIGURATION,
	RESET
} from "./actions";
import { connect } from "react-redux";

export const withStore = connect(
	(store) => ({
		store: {
			...store.tco,
			language: store.localization.language
		}
	}),
	(dispatch) => ({
		storeAction: {
			setPurchasePrice: (valueA, valueB) => dispatch({ type: SET_PURCHASE_PRICE, valueA, valueB }),
			setResidualValue: (valueA, valueB) => dispatch({ type: SET_RESIDUAL_VALUE, valueA, valueB }),
			setDrivingProfile: (value) => dispatch({ type: SET_DRIVING_PROFILE, value }),
			setEfficientHybrid: (valueA, valueB) => dispatch({ type: SET_EFFICIENT_HYBRID, valueA, valueB }),
			setAnnualMileage: (value) => dispatch({ type: SET_ANNUAL_MILEAGE, value }),
			setFuelPrice: (valueA, valueB) => dispatch({ type: SET_FUEL_PRICE, valueA, valueB }),
			setHoldingPeriod: (value) => dispatch({ type: SET_HOLDING_PERIOD, value }),
			addBus: (bus, char) => dispatch({ type: ADD_BUS, bus, char }),
			setConfiguration: (value) => dispatch({ type: SET_CONFIGURATION, value }),
			reset: () => dispatch({ type: RESET }),
		}
	})
);



// WEBPACK FOOTER //
// ./src/tco/store/withstore.js